// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1PE70","additionalInfo":"AgreementModal_additionalInfo__3rLwm"};